export const multiCustomerName = ['John Jones','Tom Jones','Sam Jones'];

export const vehicleLeadList = [
        {
            id:1,
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565",
            make:'Lexus',
            model:'LS 460',
            style:'4dr Sedan'

        },
        {
            id:2,
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565",
            make:'Lexus',
            model:'LS 460',
            style:'4dr Sedan'
        }
    ]

    export const vehicleLeadList1 = [
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
            {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
        {
            vin: 'JDK667747JDJNNNNR',
            ymm: '2025 Chevrolet Silverado 2500HD',
            trim: 'LTX',
            stockNumber: "65656565"
        },
    ]

    export const leadCustomerData = {
        businessName: "",
        customerNumber: "33332",
        customerType: 1,
        dealNumber: "535353322",
        email: "test@gmail.com",
        financePerson1Id: "",
        financePerson2Id: "",
        firstName: "test",
        lastName: "test",
        locationId: 64,
        phoneNumber: "0807278556",
        salesManagerId: 150,
        salesPerson1Id: 219,
        salesPerson2Id: ""
    }

            
